import api from 'api';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {EmailSettings, emailSettingsSchema} from 'types/EmailSettings';
import {TransportType} from 'types/TransportType';
import {AbstractTestTransport} from './common/AbstractTestTransport';
import {ResultLabel} from './common/ResultLabel';
import {Server} from 'types/transport/Abstract/AbstractServer';
import {castToSend} from 'common/yup/castToSend';

type ServerProps = Pick<Server, 'address' | 'port'>;

type Props = {
   values: EmailSettings;
};

type Props2 = {
   username: EmailSettings['incomingServer']['username'];
   password: EmailSettings['incomingServer']['password'];
   address: EmailSettings['incomingServer']['address'];
   port: EmailSettings['incomingServer']['port'];
   getValues: () => EmailSettings;
};
export const TestIncomingEmailTransport = React.memo((props: Props | Props2) => {
   let {username, password, address, port, getValues} = props as Props2;

   const {values} = props as Props;
   username = values?.incomingServer?.username || username;
   password = values?.incomingServer?.password || password;
   address = values?.incomingServer?.address || address;
   port = values?.incomingServer?.port || port;

   const disabled = !address || !port;

   let url, RenderLabels: React.ElementType<{result: any}>;
   if (!username || !password) {
      url = api.serverTest;
      RenderLabels = RenderLabelsServer;
   } else {
      url = api.testInboundEmailServer;
      RenderLabels = RenderLabelsEmail;
   }

   const getData = () =>
      !username || !password
         ? {
              address: address!,
              port: port!,
           }
         : castToSend(emailSettingsSchema, values || getValues());

   return (
      <AbstractTestTransport
         api={url}
         getData={getData}
         transportType={TransportType.enum.EMAIL}
         disabled={!!disabled}
         RenderLabels={RenderLabels}
         onlyLables
      />
   );
});

const RenderLabelsServer = ({result}: {result: boolean}) => {
   const {t} = useTranslation();

   return (
      <>
         <ResultLabel>{t('Receiving email server/account test result:')}</ResultLabel>
         <ResultLabel>
            {result
               ? t('Connection successful.\nUsername or password missing; login not tested.')
               : t('Connection not successful.')}
         </ResultLabel>
      </>
   );
};

const RenderLabelsEmail = ({result}: {result: [boolean, boolean]}) => {
   const {t} = useTranslation();

   return (
      <>
         <ResultLabel>{t('Receiving email server/account test result:')}</ResultLabel>
         <ResultLabel>
            {!result[0]
               ? t('Connection not successful.')
               : !result[1]
               ? t('Connection successful.\nLogin not successful.')
               : t('Connection successful.\nLogin successful.')}
         </ResultLabel>
      </>
   );
};
